import React from 'react';
import { RISK_COLOR, fmtDate, deriveActiveDaysRange } from './sciRiskBands';

// Per-domain drill-down: WHOIS profile, cyber-risk profile and the scan
// history strip. Data comes from /bff/domains/:domain and /:domain/history.
const Cell = ({ children }) => <td className="border border-white p-2">{children}</td>;
const Head = ({ children }) => <th className="border border-white p-2 text-left">{children}</th>;

const DomainDetail = ({ detail, history }) => {
  if (!detail) return <p className="text-gray-500 italic">Loading domain detail&hellip;</p>;

  return (
    <>
      <h4 className="font-bold mb-3">Website Profile</h4>
      <table className="w-full mb-4 border border-white text-sm">
        <thead className="bg-gray-200">
          <tr>
            <Head>Active Days Range</Head>
            <Head>Country</Head>
            <Head>Update Date</Head>
            <Head>Date Created</Head>
            <Head>Expires Date</Head>
          </tr>
        </thead>
        <tbody>
          <tr>
            <Cell>{deriveActiveDaysRange(detail.whois_created_at)}</Cell>
            <Cell>{detail.country || 'Unknown'}</Cell>
            <Cell>{fmtDate(detail.whois_updated_at)}</Cell>
            <Cell>{fmtDate(detail.whois_created_at)}</Cell>
            <Cell>{fmtDate(detail.whois_expires_at)}</Cell>
          </tr>
        </tbody>
      </table>

      <h4 className="font-bold mb-3">Cyber Risk Profile</h4>
      <table className="w-full mb-4 border border-white text-sm">
        <thead className="bg-gray-200">
          <tr>
            <Head>Last Scan Date</Head>
            <Head>On Blocklist</Head>
            <Head>Email Auth</Head>
            <Head>TLS Issuer</Head>
          </tr>
        </thead>
        <tbody>
          <tr>
            <Cell>{fmtDate(detail.scanned_at)}</Cell>
            <Cell>{detail.on_blocklist ? 'Yes' : 'No'}</Cell>
            <Cell>
              {[
                detail.has_spf && 'SPF',
                detail.has_dmarc && 'DMARC',
                detail.has_dkim && 'DKIM',
              ].filter(Boolean).join(' / ') || 'None'}
            </Cell>
            <Cell>{detail.tls_issuer || 'Unknown'}</Cell>
          </tr>
        </tbody>
      </table>

      <h4 className="font-bold mb-3">Risk History</h4>
      {!history ? (
        <p className="text-gray-500 italic">Loading history&hellip;</p>
      ) : history.length === 0 ? (
        <p className="text-gray-500 italic">No scan history available.</p>
      ) : (
        <div className="bg-white border border-gray-300 p-3">
          <div className="flex gap-px h-8 mb-2">
            {history.map((entry, i) => (
              <div
                key={entry.scan_id || i}
                className={`flex-1 ${RISK_COLOR[entry.risk_level] || 'bg-gray-300'}`}
                title={`${entry.risk_level || 'unrated'} on ${fmtDate(entry.scanned_at)}`}
              />
            ))}
          </div>
          <div className="flex justify-between text-xs text-gray-600">
            <span>{fmtDate(history[0]?.scanned_at)}</span>
            <span>{history.length} scan{history.length === 1 ? '' : 's'}</span>
            <span>{fmtDate(history[history.length - 1]?.scanned_at)}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default DomainDetail;
